import { ActionType, createReducer } from 'typesafe-actions'
import { Extents } from 'types/Extents'
import {
  currentExtentsUpdate,
  overallExtentsUpdate
} from 'components/scale/actions'

export const extents = createReducer<
  Extents,
  ActionType<typeof currentExtentsUpdate>
>([0, 15]).handleAction(currentExtentsUpdate, (state, { payload }) => payload)

export const overallExtents = createReducer<
  Extents,
  ActionType<typeof overallExtentsUpdate>
>([0, 30]).handleAction(overallExtentsUpdate, (state, { payload }) => payload)
